import { combineReducers } from "redux";
import loginReducer from "./loginReducer";
import { authorizeReducer } from "./authorizeReducer";

export default combineReducers({
  login: loginReducer,
  authorize: authorizeReducer,
});
